import { render, staticRenderFns } from "./Branding.page.vue?vue&type=template&id=0d8f0cc2&"
import script from "./Branding.page.vue?vue&type=script&lang=js&"
export * from "./Branding.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports